// Configuración del Popup Multipropósito
// Aquí puedes habilitar/deshabilitar y configurar el contenido del popup

export const popupConfig = {
  // CONTROL PRINCIPAL - Cambiar a false para deshabilitar completamente el popup
  enabled: false,
  
  // CONTENIDO DEL POPUP
  title: "Renacer no es opcional",
  content: "Ahorra tiempo y mejora tu calidad de atención en un solo movimiento. Renacer no es comenzar desde cero, es transformar, modernizar y optimizar tu gestión comercial.",
  
  // CONFIGURACIÓN DE MEDIA (imagen o video)
  mediaType: "image", // Opciones: "image", "video", "none"
  mediaUrl: "/images/popup/popup.png", // Para imágenes: ruta local o URL con altura máxima de 200 px | Para videos de YouTube: usar formato embed
  
  // EJEMPLOS DE CONFIGURACIÓN:
  // Para imagen: mediaUrl: "/images/promocion.jpg" o "https://ejemplo.com/imagen.jpg"
  // Para video de YouTube: mediaUrl: "https://www.youtube.com/embed/VIDEO_ID"
  // Ejemplo YouTube: "https://www.youtube.com/embed/dQw4w9WgXcQ"
  // TAMAÑOS RECOMENDADOS:
  // - Imágenes: 800x450px (16:9) para mejor visualización
  // - Videos: El iframe se ajusta automáticamente (16:9 ratio) siempre usar 
  
  // BOTÓN DE ACCIÓN (opcional)
  actionButton: {
    enabled: true,
    text: "Ver Etapas",
    link: "/renacimiento",
    external: false // true si es un enlace externo
  },
  
  // CONFIGURACIÓN DE COMPORTAMIENTO
  showOnce: true, // true = mostrar solo una vez por sesión, false = mostrar siempre
  autoClose: false, // true = cerrar automáticamente después de X segundos
  autoCloseDelay: 5000, // tiempo en milisegundos (solo si autoClose es true)
  
  // CONFIGURACIÓN DE ESTILO
  size: "medium", // Opciones: "small", "medium", "large"
  theme: "light" // Opciones: "light", "dark"
};

// Función para verificar si el popup debe mostrarse
export const shouldShowPopup = () => {
  if (!popupConfig.enabled) return false;
  
  if (popupConfig.showOnce) {
    const hasShown = sessionStorage.getItem('nextcoders-popup-shown');
    return !hasShown;
  }
  
  return true;
};

// Función para marcar el popup como mostrado
export const markPopupAsShown = () => {
  if (popupConfig.showOnce) {
    sessionStorage.setItem('nextcoders-popup-shown', 'true');
  }
};
